var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import Color from 'color';
import "./Widget.scss";

import WidgetGrid from "./WidgetGrid";

var Widget = (_temp2 = _class = function (_Component) {
    _inherits(Widget, _Component);

    function Widget() {
        var _temp, _this, _ret;

        _classCallCheck(this, Widget);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getThemeStyle = function () {
            var style = _this.props.style;


            var backgroundColor = style.backgroundColor || "white";

            backgroundColor = Color(backgroundColor);

            var themeStyle = void 0;

            if (backgroundColor.isDark()) {
                themeStyle = "dark";
            } else {
                themeStyle = "light";
            }

            return themeStyle;
        }, _this.getStyle = function () {
            var _this$props = _this.props,
                style = _this$props.style,
                cols = _this$props.cols,
                rows = _this$props.rows,
                area = _this$props.area;


            if (!style) {
                return false;
            }

            return style;
        }, _this.getClassName = function () {
            var _this$props2 = _this.props,
                widgetType = _this$props2.widgetType,
                widgetSize = _this$props2.widgetSize;


            var classNames = [];

            classNames.push('admin-widget');

            if (widgetType) {
                classNames.push('admin-widget--' + widgetType);
            }

            return classNames.join(' ');
        }, _this.getSize = function () {
            var widgetSize = _this.props.widgetSize;


            if (!widgetSize) {
                return {};
            }

            var sizes = {
                "xs": 2,
                "s": 4,
                "m": 8,
                "l": 12,
                "xl": 16
            };

            var grid = widgetSize.split(":");

            var cols = grid[0];
            var rows = grid[1];

            cols = sizes[cols] || parseInt(cols);
            rows = sizes[rows] || parseInt(rows);

            return {
                cols: cols,
                rows: rows
            };
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    Widget.prototype.render = function render() {
        var _props = this.props,
            id = _props.id,
            expanded = _props.expanded,
            selected = _props.selected,
            style = _props.style,
            widgetSize = _props.widgetSize;

        var _getSize = this.getSize(),
            cols = _getSize.cols,
            rows = _getSize.rows;

        var themeStyle = this.getThemeStyle();

        var className = this.getClassName();

        return React.createElement(
            'div',
            { className: className, style: style, onClick: this.props.onClick,
                'data-theme': themeStyle,
                'data-size': widgetSize,
                'data-cols': cols,
                'data-rows': rows,
                'aria-expanded': expanded,
                'aria-selected': selected },
            React.createElement(
                WidgetGrid,
                null,
                this.props.children
            )
        );
    };

    return Widget;
}(Component), _class.defaultProps = {
    id: "widget",
    expanded: false,
    selected: false,
    widgetType: undefined,
    widgetSize: "1:1",
    style: {}
}, _temp2);


export default Widget;